import React, { Component } from 'react';
import { Repeater, ItemContainer } from '../../../../library/repeater';
import MyPageKidInfoPop from '../../../mypage/mypagekidinfo/MyPageKidInfoPop';
import ChildDetail from './ChildDetail';
import DesktopLayerPopup from '../../../common/DesktopLayerPopup';
import MyPageInjector from '../../../mypage/mypagemain/MyPageInjector';
import ExperienceInjector from '../../../../library/payment/ExperienceInjector';

class WinkFreeStudyChildSelect extends Component {
    constructor(props) {
        super(props);
        this.onClickAddStudent = this.onClickAddStudent.bind(this);
    }

    onClickAddStudent(e) {
        e.preventDefault();
        let newProps = { ...this.props };
        delete newProps.studentInfo;

        DesktopLayerPopup.modal(<MyPageKidInfoPop {...newProps} isFreeStudy />);

        return false;
    }

    render() {
        const { availableStudents, selectedStudentInfoList, studentKey } =
            this.props;
        const availableStudentsWithSelection = (availableStudents || []).map(
            (student, idx) => ({
                ...student,
                isSelected:
                    selectedStudentInfoList.findIndex(
                        (item) =>
                            item.key !== studentKey && item.childIndex === idx
                    ) !== -1,
            })
        );

        return (
            <section>
                <div className="hgroup">
                    <h1 className="no-line title">학습 예정 자녀</h1>
                </div>
                <div className="dragitem-wrap">
                    <div className="dragitem">
                        <Repeater
                            arrayData={availableStudentsWithSelection}
                            propName="childInfo"
                            elementName="div"
                            className=""
                        >
                            <ItemContainer>
                                <ChildDetail
                                    handleClick={this.props.checkChildSubject}
                                    {...this.props}
                                />
                            </ItemContainer>
                        </Repeater>
                        <a
                            onClick={this.onClickAddStudent}
                            className="item-add not-move"
                        >
                            <span>아이등록</span>
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

export default ExperienceInjector()(MyPageInjector()(WinkFreeStudyChildSelect));
